import React, { useState, useEffect } from 'react';
import style from './preview.module.scss';
import { getIn18Text } from 'api';
import { Input } from 'antd';
import SiriusModal from '@web-common/components/UI/SiriusModal';
import { ReactComponent as SearchIcon } from '@/images/icons/edm/autoMarket/searchIcon.svg';
import classnames from 'classnames';
import SepIcon from '@/images/icons/edm/edm-sep-preview.svg';
import { edmOperateVarBeforeSend, getvarList } from '@web-mail-write/components/SendMail/utils';
import { useAppSelector } from '@web-common/state/createStore';
import { EDMAPI } from '../../utils';
export const PreviewContent = (props) => {
    const { onCancel, templateParams } = props;
    const [innerContent, setInnerContent] = useState(props.content);
    const [innerContacts, setInnerContacts] = useState(props.contacts || []);
    const [selectedContact, setSelectedContact] = useState(innerContacts[0]);
    const [searchKey, setSearchKey] = useState('');
    const { systemVariableList, customVariableList } = useAppSelector(state => state.configReducer);
    const [variableList, setVariableList] = useState();
    useEffect(() => {
        const data = getvarList(systemVariableList, customVariableList);
        data && setVariableList(data);
    }, [systemVariableList, customVariableList]);
    const fetchEmailContent = async () => {
        let emailContent = edmOperateVarBeforeSend(props.content);
        let content = await EDMAPI().getVariablePreview({
            contact: selectedContact,
            templateParams: templateParams,
            emailContent: emailContent || '',
        });
        setInnerContent(content.emailContent);
    };
    useEffect(() => {
        if (selectedContact) {
            fetchEmailContent();
        }
    }, [selectedContact]);
    const hasContent = props.content.length > 0;
    if (!hasContent) {
        return null;
    }
    const searchChange = (searchKey) => {
        var _a;
        setSearchKey(searchKey);
        if (searchKey) {
            const newContacts = ((_a = props.contacts) === null || _a === void 0 ? void 0 : _a.filter(contact => contact.email.includes(searchKey))) || [];
            setInnerContacts(newContacts);
        }
        else {
            setInnerContacts(props.contacts || []);
        }
    };
    const SepPreview = (title) => {
        return (React.createElement("div", { className: style.sep },
            React.createElement("div", { className: style.line }),
            React.createElement("img", { src: SepIcon }),
            React.createElement("div", null, title),
            React.createElement("img", { src: SepIcon }),
            React.createElement("div", { className: style.line })));
    };
    const EmailListComp = () => {
        var _a;
        let shouldShowSearchBar = (((_a = props.contacts) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
        return (React.createElement("div", { className: style.emailList },
            shouldShowSearchBar && (React.createElement("div", { className: style.input },
                React.createElement(Input, { prefix: React.createElement(SearchIcon, null), placeholder: getIn18Text('SOUSUOLIANXIREN'), onChange: ({ target: { value } }) => searchChange(value) }))),
            React.createElement("div", { className: style.title }, getIn18Text('YITIANJIALIANXIREN：')),
            ((innerContacts === null || innerContacts === void 0 ? void 0 : innerContacts.length) || 0) > 0 && (React.createElement("div", { className: style.emails }, innerContacts === null || innerContacts === void 0 ? void 0 : innerContacts.map(contact => {
                return (React.createElement("div", { onClick: () => {
                        setSelectedContact(contact);
                    }, className: contact.email === selectedContact.email ? style.selectedEmail : style.email }, contact.email));
            }))),
            (innerContacts === null || innerContacts === void 0 ? void 0 : innerContacts.length) === 0 && (React.createElement("div", { className: style.subtitle }, searchKey.length > 0 ? getIn18Text('WUSOUSUOJIEGUO') : getIn18Text('ZANWEITIANJIASHOUJIANREN')))));
    };
    return (React.createElement(SiriusModal, { title: getIn18Text('YULAN'), visible: !!hasContent, footer: null, headerBottomLine: true, onCancel: onCancel, centered: true, wrapClassName: classnames([style.modalWrap]), bodyStyle: { paddingTop: '20px' }, getContainer: () => document.body, width: 898 },
        React.createElement("div", { className: style.previewContainer },
            React.createElement("div", { className: style.scroller },
                React.createElement("div", { className: style.previewWrap },
                    React.createElement("div", { className: style.areaWrap },
                        React.createElement("div", { className: style.previewPc },
                            React.createElement("iframe", { title: getIn18Text('YULAN'), sandbox: "allow-scripts allow-same-origin allow-downloads", "data-alloy-tabstop": "true", tabIndex: -1, srcDoc: innerContent || props.content })),
                        SepPreview('电脑端效果')),
                    React.createElement("div", { className: style.areaWrap },
                        React.createElement("div", { className: style.previewMobile },
                            React.createElement("iframe", { title: getIn18Text('YULAN'), sandbox: "allow-scripts allow-same-origin allow-downloads", "data-alloy-tabstop": "true", tabIndex: -1, srcDoc: innerContent || props.content })),
                        SepPreview('手机端效果')),
                    EmailListComp())))));
};
